import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_build_plc_instructionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { divertZones?: string[], message_type?: string, tote_number?: string, task_id?: number, pick_ticket_id?: number, warehouse?: string, company?: string, division?: string, message_sequence?: string, tote_groupings_id?: number }): Promise<{ plc_instructions?: string, updated?: boolean }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/functions/build_plc_instructions`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

